var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnimatedFilter = function SvgAnimatedFilter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5272",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5272)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.8469,
    cy: 88.1123,
    r: 6.17347,
    fill: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.1122,
    cy: 52.1939,
    r: 15.1531,
    fill: "#FFFBE2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1498 69.8551C62.3761 70.6067 64.1495 72.3788 64.9029 74.6041C65.0663 75.1424 65.5667 75.5342 66.1585 75.5342C66.7479 75.5342 67.2466 75.1453 67.4121 74.6101C68.1638 72.3839 69.9358 70.6107 72.1611 69.8571C72.6996 69.6937 73.0913 69.1933 73.0913 68.6015C73.0913 68.0121 72.7024 67.5134 72.1672 67.3479C69.9411 66.5962 68.1678 64.8242 67.4142 62.5989C67.2508 62.0604 66.7504 61.6686 66.1586 61.6686C65.5692 61.6686 65.0705 62.0575 64.905 62.5927C64.1534 64.8188 62.3814 66.5922 60.156 67.3458C59.6175 67.5091 59.2258 68.0095 59.2258 68.6014C59.2258 69.1908 59.6147 69.6895 60.1498 69.8551V69.8551Z",
    fill: "url(#paint0_linear_1112_5272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.219 95.079C98.9926 94.3273 97.2192 92.5553 96.4658 90.33C96.3024 89.7916 95.802 89.3998 95.2102 89.3998C94.6208 89.3998 94.1221 89.7887 93.9566 90.3239C93.2049 92.5501 91.4329 94.3234 89.2076 95.077C88.6692 95.2404 88.2774 95.7408 88.2774 96.3326C88.2774 96.922 88.6663 97.4206 89.2015 97.5862C91.4277 98.3379 93.201 100.11 93.9546 102.335C94.1179 102.874 94.6183 103.265 95.2101 103.265C95.7996 103.265 96.2982 102.877 96.4637 102.341C97.2153 100.115 98.9874 98.3418 101.213 97.5882C101.751 97.4248 102.143 96.9245 102.143 96.3327C102.143 95.7432 101.754 95.2446 101.219 95.079V95.079Z",
    fill: "url(#paint1_linear_1112_5272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7242 88.1636C84.7242 88.1636 83.8265 87.871 82.5796 87.4655C78.2785 86.0651 74.8545 82.7209 73.4209 78.5201C73.0056 77.3018 72.706 76.4249 72.706 76.4249C72.5244 75.893 72.0146 75.5342 71.4404 75.5342C70.8663 75.5342 70.3566 75.8931 70.1748 76.425C70.1748 76.425 69.8755 77.3019 69.4603 78.5197C68.0266 82.7208 64.6027 86.0651 60.3018 87.4654C59.0546 87.871 58.1569 88.1636 58.1569 88.1636C57.6122 88.341 57.2449 88.839 57.2449 89.3998C57.2449 89.9606 57.6123 90.4585 58.1569 90.636C58.1569 90.636 59.0547 90.9284 60.3014 91.334C64.6026 92.7343 68.0266 96.0786 69.4602 100.279C69.8755 101.498 70.1748 102.374 70.1748 102.374C70.3566 102.906 70.8662 103.265 71.4404 103.265H71.4405C72.0147 103.265 72.5245 102.906 72.7061 102.375C72.7061 102.375 73.0057 101.498 73.4209 100.28C74.8546 96.0786 78.2785 92.7343 82.5793 91.334C83.8265 90.9284 84.7242 90.636 84.7242 90.636C85.2688 90.4585 85.6363 89.9607 85.6363 89.3998C85.6363 88.8389 85.2688 88.341 84.7242 88.1636V88.1636Z",
    fill: "url(#paint2_linear_1112_5272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2486 80.8163C91.825 80.8163 92.3125 80.4242 92.474 79.8848C93.8533 75.6509 97.1242 72.2796 101.233 70.8565C101.76 70.6924 102.143 70.1883 102.143 69.5919C102.143 68.998 101.762 68.4957 101.239 68.3294C97.1295 66.9083 93.8572 63.5383 92.476 59.3052C92.3167 58.7624 91.8275 58.3673 91.2486 58.3673C90.6722 58.3673 90.1846 58.7594 90.0232 59.2988C88.6439 63.5327 85.373 66.9041 81.2644 68.3272C80.7376 68.4913 80.3542 68.9954 80.3542 69.5918C80.3542 70.1856 80.7348 70.6879 81.2583 70.8543C85.3674 72.2753 88.6396 75.6451 90.0209 79.8777C90.18 80.421 90.6694 80.8163 91.2486 80.8163V80.8163Z",
    fill: "url(#paint3_linear_1112_5272)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5272",
    x1: 73.0913,
    y1: 61.6686,
    x2: 59.2258,
    y2: 61.6686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5272",
    x1: 102.143,
    y1: 89.3998,
    x2: 88.2774,
    y2: 89.3998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_5272",
    x1: 85.6363,
    y1: 75.5342,
    x2: 57.2449,
    y2: 75.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1112_5272",
    x1: 102.143,
    y1: 58.3673,
    x2: 80.3542,
    y2: 58.3673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnimatedFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/animated-filter.5ef93a50a9bb63055e6458d31a4420f3.svg";